// ---------------------------------------------------------------------------
// House of Projects: single source of truth for brand, legal identity,
// navigation and shared copy. Edit here, not in components.
// ---------------------------------------------------------------------------

export const BRAND = {
  name: "House of Projects",
  tagline: "Business Consultancy: Marketing, Hiring & Technology",
  logo: "/hop-logo.svg", // official supplied SVG, never recreate or alter
};

// Legal identity. Sourced from the Certificate of Incorporation and the GST
// registration certificate supplied by the client. Do NOT merge the two
// addresses: MCA address = Registered Office, GST address = Principal Place
// of Business.
export const COMPANY = {
  legalName: "HOUSEOFPROJECT TALENT AND BUSINESS MANAGEMENT PRIVATE LIMITED",
  entityType: "Private Limited Company",
  incorporated: "09 July 2026",
  cin: "U70200DL2026PTC468242",
  pan: "AAICH7953C",
  tan: "DELH22088D",
  gstin: "07AAICH7953C1ZH",
  gstRegistrationType: "Regular",
  gstValidFrom: "03 October 2026",
  // GST legal/trade name as printed on the GST certificate (no "LIMITED").
  gstLegalName: "HOUSEOFPROJECT TALENT AND BUSINESS MANAGEMENT PRIVATE",
  registeredOffice: [
    "104, Vipul Trade Centre",
    "Sector 48, Gurugram",
  ],
  principalPlace: [],
  directors: ["Namit Narayan", "Deepa Sharma"],
};

export const APPLYKAR_URL = "https://applykar.in";
export const APPLYKAR_PAGE = "/hiring";
// Set to a real number (e.g. "1,00,000+") to show it on the Hiring page. Left null so no unverified figure is published.
export const APPLYKAR_CANDIDATES = null;

// Contact details carried over from the previous site. CONFIRM before launch.
export const CONTACT = {
  phoneDisplay: "+91 89203 07850",
  phoneHref: "tel:+918920307850",
  whatsappNumber: "918920307850", // digits only, no + or spaces (required by wa.me)
  whatsappHref: "https://wa.me/918920307850",
  linkedinHref: "https://www.linkedin.com/company/house-of-projects", // CONFIRM real company page URL
  email: "namit@houseofprojectapp.com",
  emailHref: "mailto:namit@houseofprojectapp.com",
};

// Options shown in the Discovery Gate Modal ("Contact Now" flow) before a
// visitor is handed off to WhatsApp. Selecting one is required before the
// "Continue to WhatsApp" button is enabled. No Google Maps option - HOP has
// no Maps listing wired up anywhere in this codebase.
export const DISCOVERY_SOURCES = [
  { id: "google_search", label: "Google Search" },
  { id: "whatsapp", label: "WhatsApp" },
  { id: "referral", label: "Referral" },
  { id: "direct", label: "Directly Searched" },
];


export const NAV_LINKS = [
  { to: "/what-we-do", label: "What We Do" },
  { to: "/insights", label: "Why Now" },
  { to: "/arise-and-echo", label: "Arise & Echo" },
  { to: "/hiring", label: "Hiring" },
  { to: "/how-we-work", label: "How We Work" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

// Colour identity per arm (mirrors CSS custom properties in index.css).
export const ARMS = [
  {
    key: "hop",
    name: "House of Projects",
    descriptor: "IT, Tech, Business & Marketing Consulting",
    to: "/what-we-do",
    cta: "Explore capabilities",
    problem:
      "Disconnected tools, manual handoffs and digital infrastructure that was never designed around how the business actually runs.",
    capability:
      "Revenue models, campaigns, product launches, D2C and B2B marketing, plus websites, apps and automation.",
    outcome:
      "Lower operating cost, better traction and engagement, and systems built around how you actually sell.",
  },
  {
    key: "ae",
    name: "Arise & Echo",
    descriptor: "Social Media & Visibility Infrastructure",
    to: "/arise-and-echo",
    cta: "See Arise & Echo",
    problem:
      "Real expertise and capability that the right people never see, so opportunity goes elsewhere.",
    capability:
      "Positioning, content strategy, production and distribution built around a leader's expertise.",
    outcome:
      "Recognition, trust and inbound opportunity, with authority that compounds over time.",
  },
  {
    key: "ak",
    name: "Hiring & Talent",
    descriptor: "Recruitment Platform for India",
    to: "/hiring",
    cta: "See how hiring works",
    problem:
      "Good candidates and good employers keep missing each other, and small recruiters have no tools or reach.",
    capability:
      "A job portal we own, with one profile for private jobs, daily government updates, freelance work and AI Apply. Free job posting for recruiters.",
    outcome:
      "More jobs for candidates, faster hires for employers, and a ready-made digital office for small recruitment agencies.",
  },
];

export const COUNTRY_CODES = [
  { code: "+91", country: "India" },
  { code: "+1", country: "USA / Canada" },
  { code: "+44", country: "UK" },
  { code: "+61", country: "Australia" },
  { code: "+65", country: "Singapore" },
  { code: "+971", country: "UAE" },
  { code: "+966", country: "Saudi Arabia" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+81", country: "Japan" },
  { code: "+86", country: "China" },
  { code: "+92", country: "Pakistan" },
  { code: "+880", country: "Bangladesh" },
  { code: "+94", country: "Sri Lanka" },
  { code: "+27", country: "South Africa" },
  { code: "+55", country: "Brazil" },
  { code: "+52", country: "Mexico" },
  { code: "+34", country: "Spain" },
  { code: "+39", country: "Italy" },
  { code: "+31", country: "Netherlands" },
];

export const TRAINING_PLANS = [
  {
    id:1,
    name:"Interview Ready",
    price:"₹5,000",
    badge:"",
    features:[
      "1 Week Live Soft Skills Training",
      "Small Batch (Maximum 5 Students)",
      "Interview Communication",
      "Dedicated Resume Preparation",
      "ATS Friendly CV Guidance",
      "Job Search Strategy",
      "Application Guidance",
      "1-on-1 Mock Interview"
    ]
  },

  {
    id:2,
    name:"Career Accelerator",
    price:"₹10,000",
    badge:"MOST POPULAR",
    features:[
      "Everything in Interview Ready",
      "5 Industry Certifications",
      "Advanced Resume Improvement",
      "AI Tools Training",
      "Prompt Engineering",
      "Research & Analysis",
      "Software Productivity Training"
    ]
  },

  {
    id:3,
    name:"Career Launch",
    price:"₹15,000",
    badge:"",
    features:[
      "Everything in Career Accelerator",
      "3 Months Post Placement Support",
      "Professional Workplace Guidance",
      "Private Alumni Network",
      "Career Growth Support",
      "Tool Learning Assistance",
      "Community Access"
    ]
  }
];